import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import api from "@/lib/api";
import { logger } from "@/lib/logger";
import { useSEO } from "@/lib/useSEO";

export default function Shop({ initialParent }) {
  const [products, setProducts] = useState([]);
  const [params, setParams] = useSearchParams();
  const parent = initialParent || params.get("parent") || "";
  useSEO({
    title: parent ? `${parent.replace("_"," ")} — Shop` : "Shop",
    description: "Premium commercial printing, graphic design, and website design products.",
    breadcrumbs: [{ name: "Home", url: "/" }, { name: "Shop", url: "/shop" }],
  });
  useEffect(() => {
    let cancelled = false;
    const q = parent ? `?parent_type=${parent}` : "";
    api.get(`/products${q}`)
      .then(r => { if (!cancelled) setProducts(r.data); })
      .catch(err => logger.error("Shop load failed:", err));
    return () => { cancelled = true; };
  }, [parent]);
  return (
    <section className="max-w-[1400px] mx-auto px-6 md:px-12 py-16 md:py-24">
      <div className="mb-12">
        <p className="text-xs font-mono tracking-[0.3em] uppercase text-[#C5A059]">The Shop</p>
        <h1 className="font-serif text-5xl md:text-7xl mt-3">{parent ? parent.replace("_"," ") : "Every product"}</h1>
      </div>
      <div className="flex gap-4 mb-10 text-xs font-mono tracking-[0.2em] uppercase">
        {[["", "All"], ["printing", "Printing"], ["graphic_design", "Graphic Design"], ["website_design", "Website Design"]].map(([v,l]) => (
          <button key={v} onClick={() => setParams(v ? { parent: v } : {})} data-testid={`shop-filter-${v||'all'}`}
            className={`pb-1 border-b ${parent === v ? "border-[#C5A059] text-[#C5A059]" : "border-transparent text-[#555] hover:text-[#0a0a0a]"}`}>{l}</button>
        ))}
      </div>
      <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
        {products.map(p => (
          <Link key={p.id} to={`/product/${p.slug}`} data-testid={`product-card-${p.slug}`} className="group block bg-white border border-[#E5E5E5] gold-border-hover">
            <div className="aspect-square overflow-hidden bg-[#F5F5F5]">
              <img src={p.image_url} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" alt={p.name} />
            </div>
            <div className="p-5">
              <h3 className="font-serif text-xl">{p.name}</h3>
              <p className="font-mono text-sm mt-2 text-[#C5A059]">${p.base_price.toFixed(2)}</p>
              {!p.available && <p className="text-xs text-[#9A1F1F] mt-1">Requires additional printer</p>}
            </div>
          </Link>
        ))}
      </div>
    </section>
  );
}
